import axios from "axios";

const Axios = axios.create({
    // baseURL: "http://localhost:7576",
    baseURL: "https://admin_csms.laotel.com/api",
})

export default Axios